import cloneDeep from 'clone-deep'

import type { HeaderRow } from './HeaderSelectionModal'

/**
 * Drop one column. Empty cells are real cells (`''`), so the column is removed
 * even when every value in it is blank. The last remaining column is kept.
 */
export function removeHeaderColumn(headers: HeaderRow[], cellIndex: number): HeaderRow[] {
  if (headers.length === 0 || !headers[0] || headers[0].length <= 1) return headers
  if (cellIndex < 0 || cellIndex >= headers[0].length) return headers

  const newHeaders = cloneDeep(headers)
  newHeaders.forEach((row) => {
    if (cellIndex < row.length) row.splice(cellIndex, 1)
  })
  return newHeaders
}

/** Swap a column with its neighbor. Empty cells still occupy a slot and must move with the column. */
export function moveHeaderColumn(headers: HeaderRow[], cellIndex: number, direction: -1 | 1): HeaderRow[] {
  if (headers.length === 0 || !headers[0]) return headers
  const target = cellIndex + direction
  if (cellIndex < 0 || target < 0 || target >= headers[0].length) return headers

  const newHeaders = cloneDeep(headers)
  newHeaders.forEach((row) => {
    if (cellIndex < row.length && target < row.length) {
      const temp = row[cellIndex]
      row[cellIndex] = row[target]
      row[target] = temp
    }
  })
  return newHeaders
}
